/**
 * @since 0.1.0
 */
import { now } from 'fp-ts/es6/Date';
export function time(M) {
    var nowM = M.fromIO(now);
    return function (ma) { return M.chain(nowM, function (start) { return M.chain(ma, function (a) { return M.map(nowM, function (end) { return [a, end - start]; }); }); }); };
}
